import React from "react";
import FormBuilder from "../../../class/tool/FormBuilder";
import StoreSettingController from "../../../stories/_setting/StoreSettings/StoreSettingController";
import "../../../css/form/Form.css";

const StoreStoreFormSheet = props => {
    const { values, errors, handleChange, handleSave } = props;
    const rows = StoreSettingController.getRows("store");

    const buildRow = row => {
        return FormBuilder.buildInputByType(row, values, errors, change);
    }
    const change = (attribute, returnType, val, strict = false) => {
        handleChange(rows, attribute, returnType, val, strict);
    }
    const handleSubmit = event => {
        if (event !== undefined)
            event.preventDefault();

        handleSave();
    }

    return (
        <form className={"form inOverbox"} onSubmit={ handleSubmit }>
            {
                rows.map((row, index) => (
                    <div key={ index } className="row">
                        { (row.noLabel === undefined || !row.noLabel) && <label className={ row.classnameLabel }>{ row.label }</label> }
                        { buildRow(row) }
                    </div>
                ))
            }
        </form>
    )
}

export default StoreStoreFormSheet;